import React, { useEffect } from 'react';
// mui
import { Box, MenuItem } from '@mui/material';
// other libraries
import { useForm } from 'react-hook-form';
// components
import { RHFSelect } from '../../hook-form';
// redux
import { saveNewCampaign, updateSelectedCampaign } from '../../../redux/slices/campaign';
import { dispatch, useSelector } from '../../../redux/store';
// style
import { tagsBoxStyle } from '../../../styles/AutocompleteTags';
import {
    menuItemStyle,
} from '../../../styles/PersonalDetailsStyle';

const LeadSourceDropdown = () => {
    const { selectedCampaign, newCampaign } = useSelector((state) => state.campaign);
    const { sourceType } = useSelector((state) => state.schema);
    const defaultValues = {
        source: '',
        type: ''
    };
    const methods = useForm({
        defaultValues,
    });

    const {
        watch,
        setValue
    } = methods;

    const values = watch();

    useEffect(() => {
        if (selectedCampaign) {
            const statusValue = sourceType?.find((el) => selectedCampaign?.recepient?.filters?.lead_source__type__in?.includes(el.value))?.value;
            if (statusValue) {
                setValue('type', statusValue);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCampaign]);

    const handleChange = (event, data) => {
        const {
            target: { value },
        } = event;
        setValue(data, value);
        const val = { lead_source__type__in: [value] };
        if (Object.values(selectedCampaign).length > 0) {
            const updatedCampaign = { ...selectedCampaign, recepient: { ...selectedCampaign.recepient, filters: { ...selectedCampaign?.recepient?.filters, ...val } } };
            dispatch(updateSelectedCampaign(updatedCampaign));
            return;
        }
        dispatch(saveNewCampaign({ lead_source__type__in: val, source__type: [value] }));
    };

    return <Box sx={tagsBoxStyle}>
        <RHFSelect
            name='type'
            label='Type'
            value={newCampaign?.source__type || values.type}
            onChange={(e) => handleChange(e, 'type')}
            SelectProps={{ native: false, sx: { textTransform: 'capitalize' } }}
        >
            {sourceType.map((options, index) => (
                <MenuItem
                    key={index}
                    value={options.value}
                    sx={menuItemStyle}
                >
                    {options.label}
                </MenuItem>
            ))}
        </RHFSelect>
    </Box>;
};

export default LeadSourceDropdown;